import { View } from "react-native";
import { SegmentedButtons } from "react-native-paper";
import { useTranslation } from "react-i18next";

export const BoardTypes = {
  horizontal: "horizontal",
  vertical: "vertical",
  table: "table",
} as const;

type BoardTypeSelectorProps = {
  boardPresentation: string;
  setBoardPresentation: (value: string) => void;
};

export const BoardTypeSelector = ({
  boardPresentation,
  setBoardPresentation,
}: BoardTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <View>
      <SegmentedButtons
        value={boardPresentation}
        onValueChange={setBoardPresentation}
        multiSelect={false}
        style={{ width: 300 }}
        buttons={[
          // { value: BoardTypes.vertical, label: t("List") },
          {
            value: BoardTypes.horizontal,
            label: t("Board"),
          },
          {
            value: BoardTypes.table,
            label: t("Table"),
          },
        ]}
      />
    </View>
  );
};
